import { createAsyncThunk } from '@reduxjs/toolkit';

import { JsonQuery } from '@/packages/JsonQuery';

import { type TThunkApi } from '@/microfrontends/filters/shared/store';
import { jsonQueryActions } from '@/microfrontends/filters/shared/store/slices/jsonQuery';
import { locationActions } from '@/microfrontends/filters/shared/store/slices/location';
import { type TLocation } from '@/microfrontends/filters/shared/types/location';
import { tempNormalizeLocation } from '@/microfrontends/filters/shared/utils/tempNormalizeLocation';

export const applyLocation = createAsyncThunk<void, TLocation | undefined, TThunkApi>(
  'geo/applyLocation',
  async (location, thunkApi) => {
    const { getState, dispatch } = thunkApi;
    const state = getState();

    if (location) {
      const { current: jsonQuery } = state.jsonQuery;

      const nextJsonQuery = new JsonQuery(jsonQuery);
      const prevLocation = tempNormalizeLocation(state.location.data);
      const nextLocation = tempNormalizeLocation(location);

      nextJsonQuery.setLocations({ prev: prevLocation, next: nextLocation });

      dispatch(locationActions.setLocation(location));
      dispatch(jsonQueryActions.change(nextJsonQuery.toJSON()));
    }
  },
);
